// eslint-disable-next-line no-shadow
export enum ProModeTabs {
	MODELS = 'models',
	LORA = 'lora',
	SETTINGS = 'settings',
}
